import React from 'react';
import img from '../istockphoto-181100994-1024x1024.jpg'
const NotFound = () => {
    return (
        <div >
            <img src={img} alt="" />
        </div>
    );
};

export default NotFound;